import { jsx as _jsx } from "react/jsx-runtime";
import { OutlinedInput } from '@mui/material';
import { SearchRegular } from '@fluentui/react-icons';
import useSSearchInputStyles from './useSSearchInputStyles';
import { useTranslation } from 'react-i18next';
const SSearchInput = ({ ...rest }) => {
    const { t } = useTranslation();
    const { searchbarStyles } = useSSearchInputStyles();
    return (_jsx(OutlinedInput, { className: 'searchbar', "aria-placeholder": t('SearchHere'), placeholder: t('SearchHere'), sx: searchbarStyles, size: 'small', ...rest, startAdornment: _jsx(SearchRegular, { fontSize: 20 }) }));
};
export default SSearchInput;
